const KEY = "albis.calendarProvider";

/** @returns {"google"|"outlook"|null} */
export function readCalendarProvider() {
  try {
    const value = localStorage.getItem(KEY);
    return value === "google" || value === "outlook" ? value : null;
  } catch {
    return null;
  }
}

/** @param {"google"|"outlook"} provider */
export function rememberCalendarProvider(provider) {
  if (provider !== "google" && provider !== "outlook") return;
  try {
    localStorage.setItem(KEY, provider);
  } catch {
    /* private mode */
  }
}

/**
 * Google first until the parent has used a calendar. After that, the one they
 * used leads.
 * @param {"google"|"outlook"|null} [preferred]
 * @returns {Array<"google"|"outlook">}
 */
export function calendarProviderOrder(preferred = readCalendarProvider()) {
  return preferred === "outlook" ? ["outlook", "google"] : ["google", "outlook"];
}

export const CALENDAR_PROVIDER_LABEL = {
  google: "Google",
  outlook: "Outlook",
};
